import { render } from "./ChangelogModal.vue?vue&type=template&id=7fbaa500&scoped=true"
import script from "./ChangelogModal.vue?vue&type=script&lang=js"
export * from "./ChangelogModal.vue?vue&type=script&lang=js"

import "./ChangelogModal.vue?vue&type=style&index=0&id=7fbaa500&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fbaa500"]])

export default __exports__